import * as types from '../../../actions';

const initialState = {
  items: [],
  status:0,
  totalPage:0,
  numRows:0,
  item:{
      id:'',
      ppFrom:'',
      ppTo:'',
      omnuPoints:''
  },
  activity:'',
  count:'',
  errorData:''    
};

export default function(state = initialState, action) {
  const response = action.response;
  switch(action.type) {
        case types.OMNU_POINTS_PP_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: response.data,
                    status: response.status,
                    activity:types.OMNU_POINTS_PP_LIST_SUCCESS,
                    numRows:response.data.length,
                };
            }else{
                return {
                    ...state,
                    activity:types.OMNU_POINTS_PP_LIST_ERROR,
                    status: response.status,                                 
                };
            }      

        case types.OMNU_POINTS_PP_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.OMNU_POINTS_PP_ADD_SUCCESS,
                }      
            }else{
                return {
                    ...state,
                    errorData: response.data,
                    status: response.status,
                    activity:types.OMNU_POINTS_PP_ADD_ERROR,
                }    
            } 
      
        case types.OMNU_POINTS_PP_EDIT_SUCCESS: 
            if(response.status===200){ 
                return {
                    ...state,
                    item:{
                        id:response.data.id,
                        ppFrom: response.data.pp_from,
                        ppTo:response.data.pp_to,
                        omnuPoints:response.data.omnu_point,
                    },
                    status: response.status,
                    activity:types.OMNU_POINTS_PP_EDIT_SUCCESS,               
                }
            }else{
                return {
                    ...state,                    
                    status: response.status,
                    activity:types.OMNU_POINTS_PP_EDIT_ERROR,               
                }
            }          

        case types.OMNU_POINTS_PP_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items:state.items.map(item => {
                        return item.id === response.data.id ? response.data : item;
                    }),
                    status: response.status,
                    activity:types.OMNU_POINTS_PP_UPDATE_SUCCESS,         
                }    
            }else{
                return {
                    ...state,   
                    errorData: response.data,
                    status: response.status,
                    activity:types.OMNU_POINTS_PP_UPDATE_ERROR,         
                }   
            }
                          
        case types.OMNU_POINTS_PP_DELETE_SUCCESS:
            const id = response.data.id;       
            if(response.status===200){
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),             
                    status: response.status,
                    activity:types.OMNU_POINTS_PP_DELETE_SUCCESS,   
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.OMNU_POINTS_PP_DELETE_ERROR,   
                    errorData: response.data
                }
            }           

        case types.CLEAR:
            return {
                ...state,
                item:{
                  id:'',
                  name: '',
                  certificateDetails:'',
                  certificateRequired:false
                },
                activity:'',
                status:0               
            }  

        default:
            return state;
  }
};